import React,{Component} from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import "./index.css";
import "./index.scss";
import appinfo from "../../clientsJSON";
import {
    Banner,
    Menu,
    Footer,
    Sections,
    Reviews,
    Seo,
    Input,
    Client,
    Media,
    ServiceCard
} from "../../component";
import Login from "../login";
import { Notyf } from 'notyf';
import 'notyf/notyf.min.css';
import {    taskcreateActions } from "../../actions";


const notyf = new Notyf({
    types: [
      {
        type: 'success',
        background: 'green',
        duration:3000,
        dismissible:true,
        position: {
            x: 'center',
            y: 'top',
          },
      },
      {
        type: 'error',
        background: 'indianred',
        duration: 3000,
        dismissible: true,
        position: {
            x: 'center',
            y: 'top',
          },
      }
    ]});

class Home extends Component {
    constructor(){
        super();
        this.state = {
            response: {},
            price_option: null,
            questions: {},
            amount: 0,
            q_id: -1,
            mobileflow:  false,
            task: {},
            processing: false,
            lat: "",
            lon: ""
        }
    }


    render(){
        document.title = appinfo.name;
        let source=""
        source=`https://development.moonproduct.in?id=${appinfo["x-access-client-id"]}&form=${appinfo["form"]}`

        return (
            <div>
                <Menu/>
                <>
                <Banner>

                  {appinfo.template !==1 && <iframe src={source} frameBorder="0" width="100%" height="390px"></iframe>}

                </Banner>
               {appinfo.template===1&& 
               <div style={{marginTop:20}}>
                   
               <div className="services_detail_row container" style={{marginTop:-50}} >
                   
                    <div className="split2">
                        <div style={{borderRadius:"50%",width:280,height:280}}>
                            <img src={appinfo.about_us_image} alt={appinfo.title} style={{width:280,height:280}} />
                        </div>
                    </div>
                    <div className="split2" style={{flexDirection:"column",textAlign:"left"}}>
                    <h1 style={{textAlign:"center" ,color:appinfo.primaryTextColor}}>{appinfo.about_us_title}</h1>
                        <p style={{textAlign:"justify"}}>{appinfo.about_us_home}</p> 
                    </div>               
                </div>
                </div>}
                {/* Section Rendering */}
                {   
                    appinfo.home_sections.map( (single, index) => {
                        let style = {paddingBottom: 40, paddingTop: 40};
                        style["backgroundColor"] = index%2 !== 0 ? "white" : "#F6F6F6";
                        style["display"] = single.show ? "visible" : "none";

                        return (
                            <div className="About" style={style} >
                               
                                {single.cardType === "section" ?
                                    (   <>
                                       
                                            <h1 style={{textAlign:"center",color:appinfo.primaryTextColor}}>{single.title}</h1>
                                            {/* {single.type.includes(1)&&<p style={{textAlign:"center"}}>{single.descripition}</p>} */}
                                            {single.iconshow && single.image && <div>
                                         <img src={single.image} alt={single.title} style={{width:"77px" ,height:"77px" , marginLeft: "auto", marginRight: "auto", display: "flex",backgroundColor: "transparent"}}/></div>}
                                           <Sections content={single} index={index}/>
                                           {single.type.includes(1)&& <p style={{textAlign:"center"}}>
                                           <a href={"/"+appinfo.services.title}  style={{textDecoration:"none",color:appinfo.secondaryTextColors}}>
                                            <button style={{color:appinfo.secondaryTextColor,border:"none",borderRadius:0,backgroundColor:appinfo.button_color}}className="button" >VIEW ALL {appinfo.services.title} <i class="material-icons" style={{verticalAlign:"sub",height:16,fontSize:"large"}}>arrow_forward</i></button>
                                          </a>
                                        </p>}
                                          
                                        </>
                                    ) : 
                                    (<>
                                            <Reviews content={single} />
                                    </>) 
                                }

                            </div>
                        );
                    })
                }
                {appinfo.client_show && <div><Client title={appinfo.client.title} content={appinfo.client.content}/><hr></hr></div>}
                
                {appinfo.partners_show && <div><Client title={appinfo.partners.title} content={appinfo.partners.content}/><hr></hr></div>}
                
               {appinfo.media_news &&<Media/>}
                </>
                {appinfo.template===1&& <div><iframe src={source} frameBorder="0" width="100%" height="390px"></iframe></div>}
                <Seo />
              
                <Footer/>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { taskcreate, authentication } = state;
    return {
        taskcreate,
        authentication
    };
  }
export default withRouter(connect(mapStateToProps)(Home));
